export default "__VITE_ASSET__D1Ia9cKa__"